import {
  Component,
  EventEmitter,
  Input,
  Output,
  AfterContentInit,
  ContentChildren,
  QueryList,
  OnDestroy
} from '@angular/core';

import { SkyCardTitleComponent} from './card-title.component';

import { Subscription } from 'rxjs/Subscription';


export class SkyCardComponent implements AfterContentInit, OnDestroy {
  
  public size: string;

  
  public selectable: boolean;

  
  public selected: boolean;

  
  public selectedChange = new EventEmitter<boolean>();

  
  public titleComponent: QueryList<SkyCardTitleComponent>;

  public showTitle: boolean = true;

  private subscription: Subscription;

  public ngAfterContentInit() {
    this.showTitle = this.titleComponent.length > 0;

    this.subscription = this.titleComponent.changes.subscribe(() => {
      this.showTitle = this.titleComponent.length > 0;
    });
  }

  public contentClick() {
    if (this.selectable) {
      this.selected = !this.selected;
      this.selectedChange.emit(this.selected);
    }
  }

  public ngOnDestroy() {
    /* istanbul ignore else */
    /* sanity check */
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-card',
  styles: [`.sky-card {
  background-color: #fff;
  border-top: 1px solid #cdcfd2;
  border-bottom: 1px solid #cdcfd2;
  border-left: 1px solid #cdcfd2;
  border-right: 1px solid #cdcfd2;
  display: inline-flex;
  flex-direction: column;
  height: 350px;
  margin: 0 10px 10px 0;
  transition: background-color 150ms;
  vertical-align: top;
  width: 350px;
}

.sky-card-small {
  height: 250px;
  width: 225px;
}

.sky-card-selectable .sky-card-header,
.sky-card-selectable .sky-card-content {
  cursor: pointer;
}

.sky-card-selected {
  background-color: #f1eef6;
  transition: background-color 150ms;
}

.sky-card-header {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  margin: 0;
  padding: 10px 0 0 0;
}

.sky-card-heading-left,
.sky-card-heading-right {
  font-weight: normal;
  max-width: 34px;
}

.sky-card-heading-left {
  padding-left: 10px;
}

.sky-card-heading-right {
  padding-right: 10px;
}

.sky-card-heading-middle {
  flex-grow: 1;
  padding: 0 10px;
  overflow: hidden;
}

.sky-card-title {
  font-family: "Blackbaud Sans Condensed", "Helvetica Neue Condensed", "Arial Narrow";
  color: #282b31;
  font-weight: 300;
  font-size: 26px;
  margin: 0;
  line-height: 1.42857;
}

.sky-card-check {
  flex-shrink: 0;
  padding-right: 10px;
}

.sky-card-check .sky-check-wrapper {
  margin-bottom: 2px;
}

.sky-card-content {
  flex-grow: 1;
  font-weight: normal;
  margin: 0;
  padding: 10px;
  overflow: hidden;
}

.sky-card-actions {
  bottom: 0;
  flex-shrink: 0;
  text-align: center;
}

.sky-card-actions .sky-context-menu-btn {
  height: 32px;
  width: 32px;
}
`],
  template: `<section class="sky-card sky-shadow"
    [ngClass]="
      {
        'sky-card-small': size === 'small',
        'sky-card-selectable': selectable,
        'sky-card-selected': selectable &amp;&amp; selected
      }
">
  <header>

    <div (click)="contentClick()" class="sky-card-header" *ngIf="selectable || showTitle">
      <div class="sky-card-heading-middle">
        <h1 class="sky-card-title" *ngIf="showTitle">
          <ng-content select="sky-card-title"></ng-content>
        </h1>
      </div>
      <div class="sky-card-check" *ngIf="selectable">
        <sky-checkbox
          (click)="$event.stopPropagation()"
          [ngModel]="selected"
          (ngModelChange)="contentClick()"
          [label]="'card_checkbox_label' | skyResources"
          ></sky-checkbox>
      </div>
    </div>
  </header>
  <div class="sky-card-content" (click)="contentClick()">
    <ng-content select="sky-card-content"></ng-content>
  </div>
  <div class="sky-card-actions" [hidden]="actionsEl.children.length === 0" #actionsEl>
    <ng-content select="sky-card-actions"></ng-content>
  </div>
</section>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'size': [{ type: Input },],
'selectable': [{ type: Input },],
'selected': [{ type: Input },],
'selectedChange': [{ type: Output },],
'titleComponent': [{ type: ContentChildren, args: [SkyCardTitleComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
